import React, { useEffect, useState } from "react";
import { Grid, Card, CircularProgress, Box } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import DashboardTile from "../../shared/Dashboard/GraphTile";
//import DataTable from "./DashboardTable";
import {
  GetAccountPublishersListThunk,
  GetCRMDataByPubIdThunk,
  //GetDashboardTilesDataThunk,
  GetOpenRequestsDataThunk,
  GetTotalRequestsDataThunk,
  GetDailyActiveUsersDataThunk,
  GetTotalUsersDataThunk,
} from "../../../app/store/slice/dashboard-slice";
import { dispatch } from "app/store/store";
import { useDispatch, useSelector } from "react-redux";
import { isMobile, numberFormat } from "app/utils/utils";
import DateFilters from "../../layouts/shared/headers/Header/DateFilters";
import DataTable from "../../../app/Common/ReactTable/DataTable";
import { getAssetPath } from "app/utils/appHelpers";
import { ASSET_IMAGES } from "app/utils/constants/paths";
import { LightTooltip } from "app/Common/Elements";
import { useNavigate } from "react-router-dom";

const DatagridtableHeight = window.innerHeight - 392;
const cardHeight = window.innerHeight - 362;

// export const NodeColoumn = styled(span)(({ leftPadding }) => ({
//   paddingLeft: leftPadding ? leftPadding : "7px",
// }));
const sortFilters = {
  key: "Name",
  type: "ASC",
};
const columns = [
  {
    label: "Publisher",
    renderCell: (item) => (
      <span
        className={`${item.nodes ? "consentTreeIcon" : ""}`}
        style={{ paddingLeft: item.nodes ? "0px" : "8px" }}
      >
        {item.name}
      </span>
    ),
    tree: true,
    sort: { sortKey: "Name" },
    resize: true,
  },
  {
    label: "Type",
    renderCell: (item) => item.type,
    sort: { sortKey: "Type" },
    resize: true,
  },
  {
    label: (
      <LightTooltip title="Customer Relationship Management">
        <span style={{ pointerEvents: "visible", cursor: "pointer" }}>
          CRMs
        </span>
      </LightTooltip>
    ),
    renderCell: (item) => (
      <>
        {item.url &&
          item.url != undefined &&
          item.url.split(",").map((url, i) => {
            return (
              <img
                key={i}
                src={`${ASSET_IMAGES}/connection_icons/${url}`}
                width="24px"
                style={{ marginRight: "8px" }}
              />
            );
          })}
      </>
    ),
    sort: { sortKey: "Crms" },
    resize: true,
  },
  {
    label: (
      <LightTooltip title="Daily Active Users">
        <span style={{ pointerEvents: "visible", cursor: "pointer" }}>
          DAUs
        </span>
      </LightTooltip>
    ),

    renderCell: (item) => numberFormat(item.dau),
    sort: { sortKey: "Daus" },
    resize: true,
    width: "150px",
  },
  {
    label: (
      <LightTooltip title="Monthly Active Users">
        <span style={{ pointerEvents: "visible", cursor: "pointer" }}>
          MAUs
        </span>
      </LightTooltip>
    ),
    renderCell: (item) => numberFormat(item.mau),
    sort: { sortKey: "Maus" },
    resize: true,
    width: "150px",
  },
  {
    label: "Total Users",
    renderCell: (item) => numberFormat(item.total_users),
    sort: { sortKey: "Users" },
    resize: true,
    width: "150px",
  },
];

let sort = {
  Name: (array) => array.slice().sort((a, b) => a.name.localeCompare(b.name)),
  Type: (array) => array.slice().sort((a, b) => a.type - b.type),
  Crms: (array) => array.slice().sort((a, b) => a.crms - b.crms),
  Daus: (array) => array.slice().sort((a, b) => a.daus - b.daus),
  Maus: (array) => array.slice().sort((a, b) => a.mau - b.mau),
  Users: (array) => array.slice().sort((a, b) => a.total_users - b.total_users),
};

const Dashboard = () => {
  const ismobile = isMobile();
  const {
    loading,
    tileLoading,
    publishersList,
    //dashboardCardsList,
    openRequests,
    totalRequests,
    dailyActiveUsers,
    totalUsers,
    openRequestLoading,
    totalRequestLoading,
    dailyActiveUsersLoading,
    totalUsersLoading,
  } = useSelector((state) => state.DashboardReducer);
  const { dashboardDateFilter, globalAccount } = useSelector(
    (state) => state.CommonReducer
  );

  const { authUserData } = useSelector((state) => state.CommonReducer);

  const [weekDataTolltip, setWeekDataTooltip] = useState("");
  useEffect(() => {
    let text = "";
    if (dashboardDateFilter.label == "day") {
      text = "vs Previous Day";
    } else if (dashboardDateFilter.label == "week") {
      text = "vs Last Week";
    } else if (dashboardDateFilter.label == "last_week") {
      text = "vs The Week Before";
    } else if (dashboardDateFilter.label == "last_month") {
      text = "vs The Month Before";
    }
    setWeekDataTooltip(text);
    if (globalAccount) {
      // dispatch(
      //   GetDashboardTilesDataThunk({
      //     account_id: globalAccount,
      //     startDate: dashboardDateFilter.startDate,
      //     endDate: dashboardDateFilter.endDate,
      //   })
      // );
      // dispatch(
      //   GetOpenRequestsDataThunk({
      //     account_id: globalAccount,
      //     startDate: dashboardDateFilter.startDate,
      //     endDate: dashboardDateFilter.endDate,
      //     type: dashboardDateFilter.label,
      //   })
      // );
      // dispatch(
      //   GetTotalRequestsDataThunk({
      //     account_id: globalAccount,
      //     startDate: dashboardDateFilter.startDate,
      //     endDate: dashboardDateFilter.endDate,
      //     type: dashboardDateFilter.label,
      //   })
      // );
      // dispatch(
      //   GetDailyActiveUsersDataThunk({
      //     account_id: globalAccount,
      //     startDate: dashboardDateFilter.startDate,
      //     endDate: dashboardDateFilter.endDate,
      //     type: dashboardDateFilter.label,
      //   })
      // );
      // dispatch(
      //   GetTotalUsersDataThunk({
      //     account_id: globalAccount,
      //     startDate: dashboardDateFilter.startDate,
      //     endDate: dashboardDateFilter.endDate,
      //     type: dashboardDateFilter.label,
      //   })
      // );
    }
  }, [dashboardDateFilter, globalAccount]);
  // useEffect(() => {
  //   if (globalAccount) {
  //     dispatch(
  //       GetAccountPublishersListThunk({
  //         account_id: globalAccount,
  //       })
  //     );
  //   }
  // }, [globalAccount]);
  const getPublisherCrmsData = (pubId) => {
    if (pubId) {
      dispatch(
        GetCRMDataByPubIdThunk({
          account_id: globalAccount,
          pub_id: pubId,
        })
      );
    }
  };
  // useEffect(() => {
  //   dispatch(
  //     GetAccountPublishersListThunk({
  //       account_id: 1,
  //       startDate: "2022-12-14 00:00:00",
  //       endDate: "2022-12-30 23:59:59",
  //       pub_id: "",
  //     })
  //   ).then((dbres) => {});
  // }, []);

  // useEffect(() => {
  //   setDummyData(publishersList);
  // }, [publishersList]);

  const navigate = useNavigate();
  useEffect(() => {
    if (
      authUserData.is_sys_admin == "0" &&
      authUserData.user_permissions.includes("show_consent_dashboard_tab") ==
        false
    ) {
      navigate("/home/reporting");
    }
  });

  return (
    <>
      <Grid container spacing={3.75} sx={{ paddingTop: "2px" }}>
        {ismobile && (
          <Grid item xs={12}>
            <DateFilters />
          </Grid>
        )}

        {(authUserData.is_sys_admin == "1" ||
          authUserData.user_permissions.includes(
            "show_consent_open_requests"
          ) == true) && (
          <Grid item xs={12} md={6} lg={3}>
            <DashboardTile
              tileData={openRequests}
              tooltip={weekDataTolltip}
              showTolltip={false}
              loading={openRequestLoading}
            />
          </Grid>
        )}
        {(authUserData.is_sys_admin == "1" ||
          authUserData.user_permissions.includes(
            "show_consent_total_requests"
          ) == true) && (
          <Grid item xs={12} md={6} lg={3}>
            <DashboardTile
              tileData={totalRequests}
              tooltip={weekDataTolltip}
              showTolltip={false}
              loading={totalRequestLoading}
            />
          </Grid>
        )}
        <Grid item xs={12} md={6} lg={3}>
          <DashboardTile
            tileData={dailyActiveUsers}
            tooltip={weekDataTolltip}
            showTolltip={true}
            loading={dailyActiveUsersLoading}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <DashboardTile
            tileData={totalUsers}
            tooltip={weekDataTolltip}
            showTolltip={true}
            loading={totalUsersLoading}
          />
        </Grid>
        {/* {dashboardCardsList.map((cardInfo, i) => {
          return (
            <Grid key={i} item xs={12} md={6} lg={3}>
              <DashboardTile
                tileData={cardInfo}
                tooltip={weekDataTolltip}
                showTolltip={
                  cardInfo.title == "Total Users" ||
                  cardInfo.title == "Daily Active Users"
                    ? true
                    : false
                }
                loading={tileLoading}
              />
            </Grid>
          );
        })} */}

        <Grid item xs={12} md={12} lg={12}>
          {/* <DataTable
            tableData={publishersList}
            loading={loading}
            showDownloadButtons={true}
          /> */}
          <Card
            sx={{
              p: "15px",
              height: cardHeight,
              position: "relative",
            }}
          >
            {loading && (
              <Box sx={{ position: "relative" }}>
                <CircularProgress
                  sx={{
                    zIndex: 4,
                    position: "absolute",
                    top: DatagridtableHeight / 2 + "px",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    transform: "-webkit-translate(-50%, -50%)",
                    transform: "-moz-translate(-50%, -50%)",
                    transform: "-ms-translate(-50%, -50%)",
                  }}
                />
              </Box>
            )}
            <DataTable
              columns={columns}
              rows={publishersList}
              filterSort={sort}
              contentHeight={DatagridtableHeight}
              dataTree={true}
              sorting={sortFilters}
              //nodeChangeHandler={getPublisherCrmsData}
              hasCustomWidth={true}
            />
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default Dashboard;
